module.exports = __webpack_public_path__ + "static/media/main_banner_02.01465460.png";